// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectUserProblem = (state: any) => state.userProblem;
